import React from 'react'
import Header from '../Components/Header'
import useUser from '../hooks/useUser'
import Login from '../Components/Login/Login'
import { useNavigate, useParams } from 'react-router-dom'
import SideBar from '../Components/Misc/SideBar'
import Misc from '../Components/Misc/Misc'
import Document from '../Components/Misc/Document'
import DocSideBar from '../Components/Misc/DocSideBar'


function LoginPage(){
     
    const {id} = useParams();
    const {user} = useUser();               
        
    return (      
        <Login></Login>
    )
}

export default LoginPage